// extracted by mini-css-extract-plugin
export var colors = "Features-module--colors--6a906";
export var container_colors = "Features-module--container_colors--2c52a";
export var container_text = "Features-module--container_text--bbbf2";
export var features__buttons = "Features-module--features__buttons--e4e75";
export var features__center = "Features-module--features__center--37860";
export var features__container = "Features-module--features__container--a66c0";
export var features__list = "Features-module--features__list--3f527";
export var features__title = "Features-module--features__title--7abd3";
export var mobile = "Features-module--mobile--19ba9";